<div class="app-content content" *ngIf="response">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
        <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
      </div>
      <div class="content-body">
        <section id="offers-active">
          <div class="col-md-12">
            <div class="card">
              <div class="table-responsive card-body">
                <table *ngIf="response != null || response?.length > 0"
                class="table table-column table-hover">
                  <thead class="thead bg-blue1">
                    <tr>
                      <th scope="col">
                        <h5 class="text-bold-600">N°</h5></th>                      
                      <th scope="col">
                        <h5 class="text-bold-600">Usuario</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">Nombre</h5></th>
                      <th scope="col">
                        <h5 class="text-bold-600">Último acceso al sistema</h5></th>
                        <th scope="col">
                        </th>
                    </tr>
                  </thead>
                  <tbody *ngFor="let docente of response; let i = index;">
                    <tr class="ng-star-inserted">
                        <th scope="row">{{ i+1 }}</th>
                        <th scope="row">{{ docente.usuario }}</th>
                        <td scope="row">{{ docente.nombre }}</td>
                        <td scope="row" *ngIf="docente.ultimoAccesoSistema!='0001-01-01T00:00:00'">{{ convertDate(docente.ultimoAccesoSistema) }}</td>
                        <td scope="row" *ngIf="docente.ultimoAccesoSistema==='0001-01-01T00:00:00'">Acceso no registrado</td>
                        <td scope="row" class="text-center">
                            <button type="button" disabled class="btn btn-icon btn-danger mr-1"
                            triggers="hover:click:hover" placement="top"
                            ngbPopover="Elimina cuenta de docente."
                            popoverTitle="Cancelar cuenta">
                              <i class="feather ft-user-minus"></i>
                            </button>
                        </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <br><br><br>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  